import { graphql } from "~/gql";

export const UPDATE_ACTIVE_NOTIFICATION_RULES = graphql(/* GraphQL */ `
  mutation UpdateActiveNotificationRules($data: UpdateActiveNotificationRulesInput!) {
    updateActiveNotificationRules(data: $data) {
      updatedIds
      active
    }
  }
`);
